import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat, YoutubeFormatHelper } from '../../../../../../../utils/youtube-format-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';
import { YoutubeMobileBottomNavComponent } from '../../../preview-common/youtube/youtube-mobile-bottom-nav/youtube-mobile-bottom-nav.component';
import { YoutubeMobileNavbarComponent } from '../../../preview-common/youtube/youtube-mobile-navbar/youtube-mobile-navbar.component';

/**
 * In-feed video ad on the mobile home screen: the creative sits in a feed card
 * between two organic ones, with the advertiser row and the action pair below
 * it. The 16:9 placement, like the watch ad.
 */
@Component({
    selector: 'app-gen-youtube-home-feed-ad-mobile',
    imports: [
        CommonModule,
        MobileFrameComponent,
        YoutubeMobileNavbarComponent,
        YoutubeMobileBottomNavComponent,
    ],
    templateUrl: './youtube-home-feed-ad-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-home-feed-ad-mobile.component.scss',
    ]
})
export class YoutubeHomeFeedAdMobilePreviewComponent {
  @Input() data!: GenVideoPreviewData;

  /** The creative format this placement previews, found by measured ratio. */
  readonly format: VideoFormat = '16:9';

  /** Thumbnail of the 16:9 video, or '' when there isn't one yet. */
  get thumbnailUrl(): string {
    return YoutubeFormatHelper.thumbnailForFormat(this.videoIds, this.format);
  }

  /**
   * True while any link is still being measured, so the empty slot says so
   * rather than asking for a video that is about to turn up.
   */
  get isResolving(): boolean {
    return YoutubeFormatHelper.isResolvingAny(this.videoIds);
  }

  /**
   * The feed card gives the title two full-width lines, so it takes the long
   * headline and only falls back to the short one when there isn't one.
   */
  get headline(): string {
    return this.data.longHeadlines[0] || this.data.headlines[0] || 'Your headline appears here';
  }

  private get videoIds(): string[] {
    return this.data.videos.map((video) => video.videoId);
  }
}
